<template>
    <a v-if="user.id" @click="submit" :class="{ selected: inFavorites }">
        <div class="icon icon-favourites icon-right"></div>
    </a>
    <a class="empty" v-else></a>
</template>

<script>
import Request from '@Core/xhr'
import forEach from '@Utils/forEach'

import { createNamespacedHelpers } from 'vuex'

const { mapState, mapActions } = createNamespacedHelpers('user')

export default {
    
    props: {
        pid: {
            type: [String, Number],
            required: true,
            default: null
        }
    },

    data() {
        return {
            inFavorites: false,
            id: 0
        }
    },

    computed: {
        ...mapState(['user'])
    },


    created() {
        App.dispatcher.listen('favorites.loaded', response => {
            let result = response.result;
            this.inFavorites = false;
            forEach(result, (index, el) => {
                if(el.product_id == this.pid) {
                    this.inFavorites = true;
                    this.id = el.id;
                }
            })
        })

        this.getUser()
    },

    methods: {
        ...mapActions(['getUser']),

        submit() {
            if(this.inFavorites == false) {
                let request = new Request({ pid: this.pid })
                request.post('/favorites/add').then((response) => {
                    App.dispatcher.fire('favorites.loaded', response)
                })
            } else {
                let request = new Request({ id: this.id })
                request.post('/favorites/remove').then((response) => {
                    App.dispatcher.fire('favorites.loaded', response)
                })
            }
        }
    }

}
</script>
